import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LanguageSwitcher = () => {
  const { language, changeLanguage } = useLanguage();

  return (
    <div className="flex items-center">
      <button
        onClick={() => changeLanguage('et')}
        className={`px-2 py-1 text-sm font-medium transition-colors duration-200 ${
          language === 'et'
            ? 'text-[#D6CE15]'
            : 'text-gray-500 hover:text-gray-300'
        }`}
      >
        ET
      </button>
      <span className="text-gray-600 mx-1">|</span>
      <button
        onClick={() => changeLanguage('en')}
        className={`px-2 py-1 text-sm font-medium transition-colors duration-200 ${
          language === 'en'
            ? 'text-[#D6CE15]'
            : 'text-gray-500 hover:text-gray-300'
        }`}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
